import { ShowAlert } from "../../common/alert";
import { store } from "../store";

export const IS_RECORDING = "IS_RECORDING";
export const STOP_RECORDING = "STOP_RECORDING";
export const SHOW_ACCOUNT_VERIFY = "SHOW_ACCOUNT_VERIFY";
export const HIDE_ACCOUNT_VERIFY = "HIDE_ACCOUNT_VERIFY";
export const TOGGLE_RECORDING = "TOGGLE_RECORDING";
export const SET_RECORDING_TIME = "SET_RECORDING_TIME";

export const extractSecondsFromTime = (timeStamp) => {
   if (!timeStamp) return 0;
   let timeInSeconds = 0;
   timeStamp.split(":").map((s, i) => {
      let timeVal = i === 0 ? 60 * parseInt(s.trim()) : parseInt(s.trim());
      return (timeInSeconds = timeInSeconds + timeVal);
   });
   return timeInSeconds || 0;
};


export const toggleAccountVerify = () => {
   store.dispatch(toggleAccountVerifyMain());
};

export const HideAccountVerify = () => {
   store.dispatch(toggleAccountVerifyStop());
};

export const notesRecordTime = () => {
   return { currentRecordTime: store.getState().Notes?.recordTime, allowedRecordTime: store.getState().auth?.loggedInProviderDetails?.noteRecordingTimeLimit }
};

export const isLimitExceededLocal = (timeLocal) => {
   const time = extractSecondsFromTime(timeLocal)
   if (notesRecordTime().allowedRecordTime && time > notesRecordTime().allowedRecordTime) return true
   else return false
}
export const timeLimitInMinutes = () => {
   const timeLimit = notesRecordTime()?.allowedRecordTime || false
   if (!timeLimit) return null
   const minutes = timeLimit / 60
   // If it's a whole number, return as integer, otherwise return with 1 decimal precision
   return minutes % 1 === 0 ? Math.floor(minutes) : parseFloat(minutes.toFixed(1))
}

export const setTimeNotes = (time) => {
   store.dispatch({
      type: SET_RECORDING_TIME,
      payload: time
   });
}

export const toggleError = () => {
   store.dispatch({
      type: TOGGLE_RECORDING,
      payload: true
   });
}
export const resolveNoteError = () => {
   store.dispatch({
      type: TOGGLE_RECORDING,
      payload: false
   });
}

export const toggleAccountVerifyMain = () => {
   return {
      type: SHOW_ACCOUNT_VERIFY,
   };
};
export const toggleAccountVerifyStop = () => {
   return {
      type: HIDE_ACCOUNT_VERIFY,
   };
};

export const toggleRecording = () => {
   return {
      type: IS_RECORDING,
   };
};

export const stopRecording = () => {
   return {
      type: STOP_RECORDING,
   };
};

export const stopRecordingMain = () => {
   store.dispatch(stopRecording());
   const container = document.getElementById("scrollableDiv-notes-main-container-scroll");
   if (container) {
      container.scrollTo({
         top: 0,
         behavior: "smooth",
      });
   }
};

export const toggleRecordingMain = () => {
   store.dispatch(toggleRecording());
};

export const isRecordinginProgress = () => {
   return store.getState().Notes.isRecording;
};

export const showVerifyAccountBanner = () => {
   return store.getState().Notes.showVerifyAccount;
};

export const recordingLayerMain = (callback = () => { }) => {
   if (isRecordinginProgress()) {
      ShowAlert("Recording is in progress", "error");
   } else {
      callback();
   }
};
